import { render, staticRenderFns } from "./InventoryHistoryModal.vue?vue&type=template&id=188485a8&scoped=true"
import script from "./InventoryHistoryModal.vue?vue&type=script&lang=js"
export * from "./InventoryHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./InventoryHistoryModal.vue?vue&type=style&index=0&id=188485a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188485a8",
  null
  
)

export default component.exports